<template>
  <div
    v-if="
      userAccountStripeSubscription &&
      ['past_due'].indexOf(userAccountStripeSubscription.status) > -1
    "
    id="account-past-due-alert"
    class="mt-4"
  >
    <v-alert id="account-past-due-alert-alert" color="softError" icon="mdi-alert">
      {{ $t('views.myAccount.billing.errorPaymentMethod') }}
      <p v-if="showGoToAccount" class="pa-0 ma-0">
        <router-link class="primary--text" to="/account?tab=billing">
          {{ $t('views.myAccount.billing.goToAccount') }}
        </router-link>
      </p>
    </v-alert>
  </div>
</template>

<script>
import BillingMixin from '@/views/components/account/BillingMixin.js'

export default {
  mixins: [BillingMixin],
  props: {
    showGoToAccount: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
#account-past-due-alert-alert {
  .v-alert__content {
    font-weight: 400;
  }
}
</style>
